import { withStyles } from '@material-ui/core/styles';
import MuiMenuItem from '@material-ui/core/MenuItem';
//
import colors from 'theme/colors';

const { lightBackgroundBase, white } = colors;

const MenuItem = withStyles({
  root: {
    '&:focus': {
      backgroundColor: white,
    },
    '&:hover': {
      backgroundColor: lightBackgroundBase,
    },
  },
})(MuiMenuItem);

export default MenuItem;
